import React, { useEffect } from "react";
import styles from "../../assets/styles/_concept.module.scss";
// import mp4 from "../../assets/videos/concept.mp4";
import mp4 from "../../assets/images/concept/concept-movie.mp4.png";
import conceptContent from "../../assets/images/concept/concept-img01.svg.png";
import conceptContent1 from "../../assets/images/concept/structure.png";
import conceptContent2 from "../../assets/images/concept/conceptContent2.png";
import conceptContent3 from "../../assets/images/concept/concept-img02.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Breadcrumb from "../common/breadcrum";
import MaskBgAnimation from "../common/MaskBgAnimation";
import SlideProduct from "../common/slideProduct";
import BtnLearnMore from "../common/btnLearnMore";
import { Link } from "react-router-dom";

const ConceptPageComponent = () => {
  useEffect(() => {
    const handleScroll = () => {
      const elementsContainer = document.querySelectorAll(
        `.${styles.conceptContentOrder}`
      );

      elementsContainer.forEach((element) => {
        const rect = element.getBoundingClientRect();
        const inViewport = rect.top < window.innerHeight && rect.bottom > 0;
        if (inViewport) {
          element.classList.add(styles.animation);
        } else {
          element.classList.remove(styles.animation);
        }
      });
    };
    // Lắng nghe sự kiện scroll
    window.addEventListener("scroll", handleScroll);

    // Gọi kiểm tra ban đầu
    handleScroll();

    // Dọn dẹp sự kiện khi component bị hủy
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });
  const isMobile = window.innerWidth < 576;

  return (
    <div className={`${styles.conceptPage} ConceptPage`}>
      <div className={styles.conceptHead}>
        <div className={styles.conceptHeadTitle}>CONCEPT</div>
        <div className={styles.conceptHeadDecs}>
          <div className={styles.conceptHeadDecsTitle}>
            <span>
              自分の髪に、
              <br className={styles.hide} />
              本当に合うものを。
            </span>
          </div>
          <div className={styles.conceptHeadDecsDesc}>
            <span>コラーゲン*1溶け込む美容酸素水※で髪の保水パック</span>
          </div>
          <div className={styles.conceptHeadDecsDescSmall}>
            <span>
              ＜シャンプー・トリートメント・ヘアミルク＞ <br />
              *1乳酸桿菌／加水分解コラーゲン発酵液エキス（保湿成分）
              <br />
              ※水、酸素、*1、ヒアルロン酸Na、ヒアルロン酸ヒドロキシプロピルトリモニウムの複合成分（全て保湿成分）
              <br />
              ＜ヘアオイル＞
              <br />
              *1イソステアロイル加水分解コラーゲンAMPD（保湿成分）
              <br />
              ※水、酸素、*1、ヒアルロン酸Naの複合成分（全て保湿成分）
            </span>
          </div>
          <div className={styles.conceptHeadDecsImg}>
            <img src={mp4} alt="concept" />
          </div>
        </div>
        <div className={styles.conceptHeadTitleEnd}>
          あなたの髪質に合う処方で、
          <br className={styles.hide} />
          <div className={styles.conceptHeadTitleEndBold}>
            キレイをめぐらせる
          </div>
        </div>
      </div>
      <Link to="/hair-check" style={{ textDecoration: "none" }}>
        <div className={styles.btnCheckHair}>
          <BtnLearnMore
            bgLinear="linear-gradient(274.77deg, #73c6ff 6.86%, #F0CEFF 96.15%)"
            arrowSmall
          >
            <div className={styles.txtWrap}>
              <div className={styles.txtSmall}>あなたは太髪？細髪？</div>
              髪質診断をやってみる
            </div>
          </BtnLearnMore>
        </div>
      </Link>

      <div className={`${styles.conceptContent} ${styles.conceptContentRight}`}>
        <MaskBgAnimation SPsmall>
          <div className={styles.conceptContentOrder}>
            <span>01</span>
          </div>
          <div className={styles.conceptContentDecs}>
            <div className={styles.conceptContentDecsList}>
              <div className={styles.conceptContentDecsHeadNote}>
                髪にうるおいをめぐらせる
              </div>
              <div
                className={styles.conceptContentDecsHead}
                style={{ marginLeft: "-20px" }}
              >
                「美容酸素水※処方」
              </div>
              <div className={styles.conceptContentDecsDesc}>
                <div>一般的なシャンプー・トリートメントの </div>
                <div>成分構成の50%以上を占める「水」に着目 。</div>
                <div>特殊製法で空気中に逃げ出さない「酸素水*1」</div>
                {isMobile ? (
                  <>
                    <div>そこにコラーゲン*2、ヒアルロン酸*3を</div>
                    <div>溶け込ませた「美容酸素水※」で髪に</div>
                    <div>うるおいめぐらせます。</div>
                  </>
                ) : (
                  <>
                    <div>そこにコラーゲン*2、ヒアルロン酸*3を溶け込ませた</div>
                    <div>「美容酸素水※」で髪にうるおいめぐらせます。</div>
                  </>
                )}
              </div>
              <div className={styles.conceptContentDecsListImg}>
                <img src={conceptContent1} alt="concept content" />
              </div>
              <div className={styles.conceptContentDecsEnd}>
                ＜シャンプー・トリートメント・ヘアミルク＞
                <br />
                *1水、酸素（全て保湿成分）
                <br />
                *2乳酸桿菌／加水分解コラーゲン発酵液エキス（保湿成分）
                <br />
                *3ヒアルロン酸Na、ヒアルロン酸ヒドロキシプロピルトリモニウム（全て保湿成分）
                <br />
                ※*1、*2、*3の複合成分（全て保湿成分）
                <br />
                ＜ヘアオイル＞
                <br />
                *1水、酸素（全て保湿成分）
                <br /> *2イソステアロイル加水分解コラーゲンAMPD（保湿成分）
                <br /> *3ヒアルロン酸Na（保湿成分）
                <br />
                ※*1、*2、*3の複合成分（全て保湿成分）
              </div>
            </div>
            <div
              className={`${styles.conceptContentDecsImg} ${styles.conceptContentDecsImgSp}`}
            >
              <img src={conceptContent1} alt="concept content" />
            </div>
          </div>
        </MaskBgAnimation>
      </div>

      <div className={`${styles.conceptContent} ${styles.conceptContentLeft}`}>
        <MaskBgAnimation revert SPsmall>
          <div className={styles.conceptContentOrder}>
            <span>02</span>
          </div>
          <div
            className={`${styles.conceptContentDecs} ${styles.conceptContentDecsMaxWidth}`}
          >
            <div className={styles.conceptContentDecsImg}>
              <img src={conceptContent2} alt="concept content" />
            </div>
            <div className={styles.conceptContentDecsList}>
              <div
                className={`${styles.conceptContentDecsHeadNote} ${styles.mbMiniSize}`}
              >
                髪質にあわせてうるおいめぐる
              </div>
              <div className={styles.conceptContentDecsHead}>
                髪質パーソナライズ
              </div>
              <div className={styles.conceptContentDecsDesc}>
                {isMobile ? (
                  <>
                    <div>髪質に合わせて簡単に選べるラインナップ</div>
                    <div>普通〜太い髪・硬い髪の方:</div>
                    <div>DEEP MOIST(ディープモイスト)</div>
                    <div>普通〜細い髪・柔らかい髪の方:</div>
                    <div>SLEEK MOIST(スリークモイスト)</div>
                    <div>
                      界面活性剤とヘアケア成分の設計を変え、どちらの髪質でもうるおいとまとまりを
                    </div>
                    <div>感じていただけます。</div>
                  </>
                ) : (
                  <>
                    <div>髪質に合わせて簡単に選べるラインナップ</div>
                    <div>
                      普通〜太い髪・硬い髪の方：DEEP MOIST(ディープモイスト){" "}
                    </div>
                    <div>
                      普通〜細い髪・柔らかい髪の方：SLEEK
                      MOIST(スリークモイスト){" "}
                    </div>
                    <div>界面活性剤とヘアケア成分の設計を変え、</div>
                    <div>
                      どちらの髪質でもうるおいとまとまりを感じていただけます。{" "}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </MaskBgAnimation>
      </div>
      <div className={`${styles.conceptContent} ${styles.conceptContentRight}`}>
        <MaskBgAnimation SPsmall>
          <div className={styles.conceptContentOrder}>
            <span>03</span>
          </div>
          <div className={styles.conceptContentDecs}>
            <div className={styles.conceptContentDecsList}>
              <div className={styles.conceptContentDecsHeadNote}>
                心にうるおいめぐる
              </div>
              <div className={styles.conceptContentDecsHead}>
                ビューティー{isMobile && <br />}フレグランス
              </div>
              <div className={styles.conceptContentDecsDesc}>
                {isMobile ? (
                  <>
                    <div>心にうるおいがめぐる淡く美しい香り</div>
                    <div> DEEP MOIST:</div>
                    <div> ホワイトフローラルエアーの香り</div>
                    <div> SLEEK MOIST:</div>
                    <div> サボンフローラルエアーの香り</div>
                  </>
                ) : (
                  <>
                    <div> 心にうるおいがめぐる淡く美しい香り</div>
                    <div>DEEP MOIST：ホワイトフローラルエアーの香り</div>
                    <div>SLEEK MOIST：サボンフローラルエアーの香り</div>
                  </>
                )}
              </div>
            </div>
            <div className={styles.conceptContentDecsImg}>
              <img src={conceptContent} alt="concept content" />
            </div>
          </div>
        </MaskBgAnimation>
      </div>
      <div className={`${styles.conceptContent} ${styles.conceptContentLeft}`}>
        <MaskBgAnimation revert SPsmall>
          <div className={styles.conceptContentOrder}>
            <span>04</span>
          </div>
          <div className={styles.conceptContentDecs}>
            <div
              className={`${styles.conceptContentDecsImg} ${styles.conceptContentDecsImgSp}`}
            >
              <img src={conceptContent3} alt="concept content" />
            </div>
            <div className={styles.conceptContentDecsList}>
              <div className={styles.conceptContentDecsHead}>
                クリーン・{isMobile && <br />}ビューティー
              </div>
              <div className={styles.conceptContentDecsDesc}>
                {isMobile ? (
                  <>
                    <div>大量発生したクラゲから抽出した</div>
                    <div>ジェリーコラーゲン*（ミズクラゲ由来）をヘ</div>
                    <div>アケア成分として採用。</div>
                    <div>海洋環境を守りながら髪のうるおいを</div>
                    <div>提供します。</div>
                  </>
                ) : (
                  <>
                    <div>大量発生したクラゲから抽出した</div>
                    <div>ジェリーコラーゲン*（ミズクラゲ由来）を</div>
                    <div>ヘアケア成分として採用。</div>
                    <div>海洋環境を守りながら髪のうるおいを提供します。</div>
                  </>
                )}
              </div>
              <div className={styles.conceptContentDecsListImg}>
                <img src={conceptContent3} alt="concept content" />
              </div>
              <div className={styles.conceptContentDecsEnd}>
                *　加水分解コラーゲン（保湿成分）
              </div>
            </div>
          </div>
        </MaskBgAnimation>
      </div>
      <SlideProduct />
      <Breadcrumb
        data={[
          {
            title: "TOP",
            link: "/",
          },
          {
            title: "CONCEPT",
            link: "/concept",
          },
        ]}
      />
    </div>
  );
};

export default ConceptPageComponent;
